import React, { FC, useState } from 'react'
import { IonContent, IonModal, IonHeader, IonFooter } from '@ionic/react'
import { Input } from '@cps'
import './index.scss'

interface IProps {
  reject?: any;
  resolve?: any;
}

const InputTableModal: FC<IProps> = ({ reject, resolve }) => {
  const [tableAlias, setTableAlias] = useState('')

  const handleSave = () => {
    tableAlias && resolve(tableAlias)
  }

  return (
    <IonModal
      isOpen
      showBackdrop
      backdropDismiss
      cssClass='input-table-modal'
      onDidDismiss={() => reject()}
    >
      <IonHeader>
        <div className='table-title'>
          <span>{i18n.t('result.inputTableCodeTitle')}</span>
          <i className='iconfont icon-close' onClick={() => reject()}></i>
        </div>
      </IonHeader>
      <IonContent>
        <div className='table-content'>
          <Input
            autoFocus
            value={tableAlias}
            onChange={(e) => {
              setTableAlias(e.target.value)
            }}
          />
        </div>
      </IonContent>
      <IonFooter className='table-footer'>
        <div className={`btn ${!tableAlias ? 'disabled' : ''}`} onClick={handleSave}>{i18n.t('newCart.confirm')}</div>
      </IonFooter>
    </IonModal>
  )
}

export default InputTableModal
